module.exports = __webpack_public_path__ + "static/media/attract-talent.fd2d8155.png";